<template>
  <div class="flex flex-col gap-0 justify-center items-start">
    <span class="text-[24px] font-bold text-[#222222] leading-[26px]">
      <slot />
    </span>
    <span class="font-medium text-[12px] text-[#222222]">{{ title }}</span>
  </div>
</template>

<script>
/**
 * Component to show a single unpacked order card
 */
export default {
  name: 'UnpackedCard',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>
